import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";

const getUsers = (clinicId) => {
    return axios.get(`${API_URL}clinics/${clinicId}/users`);
};

const getUserById = (clinicId,userId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users/"+userId)
}

const updateUser = (clinicId, userId, data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/users/"+userId, data)
}

const changePassword = (clinicId,userId,data)=>{
    return axios.post(API_URL+"clinics/"+clinicId+"/users/"+userId+"/change-password",data)
}

const getUserReminder = (clinicId,userId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/users/"+userId+"/reminder-settings")
}
const updateUserReminder = (clinicId,userId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/users/"+userId+"/reminder-settings",data)
}
const usersService = {
    getUsers,
    getUserById,
    updateUser,
    changePassword,
    getUserReminder,
    updateUserReminder
}

export default usersService